/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box, Button, FlexContainer, theme } from "@nordcloud/gnui";
import { Provider, SearchV2SortField } from "~/generated/graphql";
import { SearchBoxContainer, SortDirection } from "~/components";
import { useToggle } from "~/hooks";
import { AttachToEnv } from "../../AttachToEnv";
import { EstateSortV2 } from "../EstateSortV2";
import { ESTATE_SORT_OPTIONS } from "./types";

type Props = {
  search: string;
  setSearch: (value: string) => void;
  disabledAttachment: boolean;
  sortField: string;
  sortDirection: SortDirection;
  onSortSelect: (value: SearchV2SortField) => void;
  onSortOrderChange: (value: SortDirection) => void;
  resources: {
    nid: string;
    provider: Provider;
  }[];
  refresh?: () => void;
};

export function ParametersBar({
  search,
  setSearch,
  disabledAttachment,
  sortField,
  sortDirection,
  onSortSelect,
  onSortOrderChange,
  resources,
  refresh,
}: Props) {
  const [showAttachmentSidebar, toggleShowAttachmentSidebar] = useToggle(false);

  return (
    <>
      <Box boxStyle="lightGrey" marginBottom={theme.spacing.spacing04}>
        <FlexContainer justifyContent="space-between">
          <FlexContainer alignItems="center" wrap="wrap">
            <span css={{ marginRight: theme.spacing.spacing04 }}>
              <EstateSortV2<SearchV2SortField>
                sortField={sortField}
                sortDirection={sortDirection}
                options={ESTATE_SORT_OPTIONS}
                onSortOrderChange={onSortOrderChange}
                onSortSelect={onSortSelect}
              />
            </span>
            <SearchBoxContainer
              searchInput={search}
              setSearchInput={setSearch}
              width="20rem"
            />
          </FlexContainer>
          <FlexContainer>
            <Button
              disabled={disabledAttachment}
              icon="link"
              marginRight={theme.spacing.spacing04}
              onClick={toggleShowAttachmentSidebar}
            >
              Attach to Environments
            </Button>
            <Button
              disabled
              icon="export"
              severity="medium"
              marginRight={theme.spacing.spacing04}
            >
              Export To CSV
            </Button>
          </FlexContainer>
        </FlexContainer>
      </Box>
      <AttachToEnv
        allowMultipleAssignment
        resources={resources}
        refresh={refresh}
        isOpen={showAttachmentSidebar}
        saveSelections={false}
        onClose={toggleShowAttachmentSidebar}
      />
    </>
  );
}
